export function isEnvironmentServerSide() {
  return typeof window === "undefined";
}
